import * as React from 'react';
import { FC } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '../../hooks';
import { Icon } from '../icon';

import { IconWrapper, InlineAlertMessage, InlineAlertWrapper } from './inline-alert.styled';
import { InlineAlertProps } from './types';

/**
 * A simple pattern for displaying alerts inline with the content they are referring to.
 */
const InlineAlert: FC<InlineAlertProps> = ({ message, icon: iconOption }) => {
  const { token } = useTheme();
  const isTablet = useMediaQuery('tablet');

  const icon = iconOption ? iconOption : 'info';

  return (
    <InlineAlertWrapper aria-live="polite" aria-atomic>
      <IconWrapper>
        <Icon
          icon={icon}
          color="icon-default"
          aria-hidden
          width={token(isTablet ? 'width-icon' : 'width-icon-small')}
          height={token(isTablet ? 'height-icon' : 'height-icon-small')}
          data-testid="inline-alert-icon"
        />
      </IconWrapper>
      <InlineAlertMessage>{message}</InlineAlertMessage>
    </InlineAlertWrapper>
  );
};

export default InlineAlert;
